"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PortalPermissions;
(function (PortalPermissions) {
    PortalPermissions["readScenario"] = "READ_SCENARIO";
    PortalPermissions["upsertScenario"] = "UPSERT_SCENARIO";
    PortalPermissions["deleteScenario"] = "DELETE_SCENARIO";
    PortalPermissions["upsertRegimeType"] = "UPSERT_REGIME_TYPE";
    PortalPermissions["deleteRegimeType"] = "DELETE_REGIME_TYPE";
    PortalPermissions["upsertRegimePeriod"] = "UPSERT_REGIME_PERIOD";
    PortalPermissions["deleteRegimePeriod"] = "DELETE_REGIME_PERIOD";
})(PortalPermissions = exports.PortalPermissions || (exports.PortalPermissions = {}));
//# sourceMappingURL=PortalPermissions.js.map